import Vue from "vue";
import Vuex from "vuex";

//MODULES
import User from "@/views/User/store";
import Blog from "@/views/Blog/store";
import Ebooks from "@/views/Ebooks/store";
import Plans from "@/views/Plans/store";
import Meditation from "@/views/Meditation/store";
import Humor from "@/views/Humor/store";
import Tasks from "@/views/Tasks/store";
import Manage from "@/views/Manage/store";
import Professional from "@/views/Professional/store";
import ContentPages from "@/views/Content/store";
import Company from "@/views/Company/store";

Vue.use(Vuex);

export default new Vuex.Store({
  state: {
    isLoading: false,
    menuOpen: false,
    isDesktop: null,
    imageFileUrl: null,
    file: null,
    audio: null,
    modalCategory: null,
  },
  getters: {
    isLoading(state) {
      return state.isLoading;
    },
    menuOpen(state) {
      return state.menuOpen;
    },
    isDesktop(state) {
      return state.isDesktop;
    },
    imageFileUrl(state) {
      return state.imageFileUrl;
    },
    file(state) {
      return state.file;
    },
    audio(state) {
      return state.audio;
    },
    modalCategory(state) {
      return state.modalCategory;
    },
  },
  mutations: {
    SET_IS_LOADING(state, value) {
      state.isLoading = value;
    },
    SET_MENU_OPEN(state, value) {
      state.menuOpen = value;
    },
    SET_IS_DESKTOP(state, value) {
      state.isDesktop = value;
    },
    SET_IMAGE_FILE_URL(state, value) {
      state.imageFileUrl = value;
    },
    SET_FILE(state, value) {
      state.file = value;
    },
    SET_AUDIO(state, value) {
      state.audio = value;
    },
    SET_MODAL_CATEGORY(state, value) {
      state.modalCategory = value;
    },
  },
  actions: {
    setIsLoading(context, value) {
      context.commit("SET_IS_LOADING", value);
    },
    toggleFormFixed(context) {
      if (context.getters.isDesktop) {
        context.commit(
          "setActiveFormFloating",
          !context.getters.activeFormFloating
        );
        if (context.getters.activeFormFloating) {
          document
            .getElementsByTagName("body")[0]
            .classList.add("overflow-hidden");
          document
            .getElementsByClassName("backdrop_bar")[0]
            .classList.remove("d-none");
        } else {
          document
            .getElementsByTagName("body")[0]
            .classList.remove("overflow-hidden");
          document
            .getElementsByClassName("backdrop_bar")[0]
            .classList.add("d-none");
        }
      } else {
        if (context.getters.activeMenuFooter) {
          context.commit("setActiveMenuFooter", false);
        } else {
          context.commit("setActiveMenuFooter", true);
        }
      }
    },
    setMenuOpen(context, value) {
      context.commit("SET_MENU_OPEN", value);
    },
    stateChangedUserFirebase(context, user) {
      context.dispatch("setIsLoading", true);
      context.dispatch("User/fetchUser", user);
    },
    setImageFileUrl(context, value) {
      context.commit("SET_IMAGE_FILE_URL", value);
    },
    setFile(context, value) {
      context.commit("SET_FILE", value);
    },
    setAudio(context, value) {
      context.commit("SET_AUDIO", value);
    },
    setModalCategory(context, value) {
      context.commit("SET_MODAL_CATEGORY", value);
    },
    setDataDefault(context, [mutationName, value]) {
      context.commit(`${mutationName}`, value);
    },
    getSlugify(context, text) {
      if (!text || text === "") {
        return "";
      }

      return text
        .normalize("NFD") // separa letras de acentos
        .replace(/[\u0300-\u036f]/g, "") // remove os acentos
        .replace(/[^a-zA-Z0-9\s-]/g, "") // remove caracteres especiais
        .replace(/\s+/g, "-") // substitui espaços por hífen
        .replace(/-+/g, "-") // colapsa múltiplos hifens
        .replace(/^-+|-+$/g, "") // remove hifens do início e fim
        .toLowerCase(); // converte para minúsculas
    },
  },
  modules: {
    User,
    Blog,
    Ebooks,
    Plans,
    Meditation,
    Humor,
    Tasks,
    Manage,
    Professional,
    ContentPages,
    Company,
  },
});
